/*
 * web_interface.js
 * - get options from address
 * - html runner
 *
 * author: minchul lee (minchul.lee@aceworks.ai)
 * date: 2022.04.22
 */

class WebInterface {
  constructor() {
    const input_url = document.URL;
    let web_server_addr: string = input_url.split("/")[2].split(":")[0];
    let query: string | undefined = input_url.split("?")[1];
    let options: Record<string, string> = query ? this.getOptions(query) : {};
  }

  getOptions(query: string): Record<string, string> {
    let opts_str = query.split("&");
    let options: Record<string, string> = {};
    for (var opt of opts_str) {
      options[opt.split("=")[0]] = opt.split("=")[1];
    }
    return options;
  }
}

export default new WebInterface();
